// extracted by mini-css-extract-plugin
export var wordContainer = "_ms-0";